import React from 'react'
import WorkListViewStoreProviderRop from 'context/WorkListViewStore/Rop/WorkListViewStore.rop'
import PageContainerDesktop from '../../../../components/PageContainer/layout/PageContainer.desktop'
import { WorkListView } from './components/WorkListView/WorkListView'

const WorkListViewRopDesktop = props => (
  <WorkListViewStoreProviderRop {...props}>
    <PageContainerDesktop>
      <WorkListView />
    </PageContainerDesktop>
  </WorkListViewStoreProviderRop>
)

export default WorkListViewRopDesktop
